
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Phone, Calendar, X, ChevronUp, BookOpen, MessageCircle } from "lucide-react";
import { ScheduleCallModal } from "./ScheduleCallModal";
import { openWhatsApp } from "@/utils/whatsapp";
// Pre-generated PDF path - make sure to place your PDF at public/documents/brochure.pdf
const BROCHURE_PDF_PATH = '/documents/brochure.pdf';


export const FloatingButtons = () => {
  const [isExpanded, setIsExpanded] = useState(false); // Start collapsed by default
  const [showScheduleModal, setShowScheduleModal] = useState(false);

  const buttons = [
    {
      icon: MessageCircle,
      label: "WhatsApp",
      action: () => openWhatsApp('Hello! I would like to know more about your loan services.'),
      color: "bg-green-500 hover:bg-green-600"
    },

    {
      icon: Phone,
      label: "Call Now",
      action: () => window.open('tel:+919324471736'),
      color: "bg-blue-500 hover:bg-blue-600"
    },
    {
      icon: Calendar,
      label: "Schedule Call",
      action: () => setShowScheduleModal(true),
      color: "bg-orange-500 hover:bg-orange-600"
    },
    {
      icon: BookOpen,
      label: "Download Brochure",
      action: () => {
        try {
          // Create a temporary link element
          const link = document.createElement('a');
          link.href = BROCHURE_PDF_PATH;
          link.download = 'white-pearl-brochure.pdf';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          console.error('Error downloading brochure:', error);
          alert('Failed to download brochure. Please try again.');
        }
      },
      color: "bg-purple-500 hover:bg-purple-600"
    }
  ];

  return (
    <>
      <div style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        alignItems: 'flex-end'
      }}>
        {isExpanded && (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            marginBottom: '10px',
            borderRadius: '50px',
            overflow: 'hidden',
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
          }}>
            {buttons.map((button, index) => (
              <Button
                key={index}
                onClick={button.action}
                style={{
                  backgroundColor: button.color.includes('green') ? '#22c55e' :
                                 button.color.includes('purple') ? '#a855f7' :
                                 button.color.includes('blue') ? '#3b82f6' :
                                 '#f97316',
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  padding: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                title={button.label}
              >
                <button.icon size={24} />
              </Button>
            ))}
          </div>
        )}

        <Button
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            backgroundColor: '#3b82f6',
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
            transition: 'all 0.2s ease'
          }}
        >
          {isExpanded ? <X size={28} /> : <ChevronUp size={28} />}
        </Button>
      </div>

      {/* Apply Now Button */}
      <Button
        onClick={() => openWhatsApp('Hi! I want to apply for a loan')}
        style={{
          position: 'fixed',
          bottom: '30px',
          left: '30px',
          zIndex: 9999,
          backgroundColor: '#10b981',
          color: 'white',
          padding: '12px 24px',
          borderRadius: '50px',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
          fontWeight: 'bold',
          fontSize: '16px',
          transition: 'all 0.2s ease'
        }}
      >
        Apply Now
      </Button>

      <ScheduleCallModal
        isOpen={showScheduleModal}
        onClose={() => setShowScheduleModal(false)}
      />
    </>
  );
};
